import { BaseModel } from "sjs-base-model";
import configuration from '../../utilities/configuration';
import UserDetailsModel from "../../models/user/UserDetailsModel";
import * as EffectUtility from "../../utilities/EffectUtility";


export async function requestAllUsersDetails() {
    const endpoint = configuration.apiServer + configuration.apiUsersPath;
    return EffectUtility.getToModel(UserDetailsModel, endpoint);
}

export async function requestUserDetails(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId;
    return EffectUtility.getToModel(UserDetailsModel, endpoint);
}

export async function editUserDetails(user) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + user.id;
    return EffectUtility.putToModel(BaseModel, endpoint, user, true, true);
}

export async function sendInvitation(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/password/sendInvitation";
    return EffectUtility.putToModel(BaseModel, endpoint);
}

export async function lockUser(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/revoke";
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

export async function unlockUser(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/grant";
    return EffectUtility.putToModel(BaseModel, endpoint);
}

export async function initUser(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/init";
    return EffectUtility.putToModel(BaseModel, endpoint);
}

export async function saveUserDetails(userId, details) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/saveDetails";
    return EffectUtility.putToModel(BaseModel, endpoint, details);
}

export async function resetPassword(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/password/reset";
    return EffectUtility.putToModel(BaseModel, endpoint);
}

export async function acceptPrivacyNotice(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId + "/accept";
    return EffectUtility.putToModel(BaseModel, endpoint);
}

export async function deleteUser(userId) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath + "/" + userId;
    return EffectUtility.deleteToModel(BaseModel, endpoint, {}, true, true);
}
